"use client";

import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";

const TELEGRAM_URL = "https://t.me/peekproduct";

export function NewsletterWidget() {
  return (
    <div className="bg-card border border-border rounded-2xl p-5">
      <div className="flex items-center gap-2 mb-3">
        <Send className="h-4 w-4 text-primary" />
        <h3 className="text-sm font-semibold text-foreground">
          Будьте в курсе
        </h3>
      </div>
      <p className="text-xs text-foreground-secondary mb-1">
        <span className="line-through text-foreground-tertiary">
          Еженедельная email-рассылка
        </span>
      </p>
      <p className="text-xs text-foreground-secondary mb-4">
        Все новости, лучшие продукты недели и обновления – в нашем Telegram-канале
      </p>
      <Button
        asChild
        variant="secondary"
        className="w-full rounded-full"
        size="sm"
      >
        <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer">
          <Send className="h-3.5 w-3.5 mr-2" />
          Подписаться в Telegram
        </a>
      </Button>
    </div>
  );
}
